import { LzTColors } from "@lz/typings/types";
import { lzFNotificationsMessageRemove } from "./functions";

export const lzFNotificationsShow = (type: 'default' | LzTColors, message: string, heading: string, timeoutMilliseconds: number): void => {
    // Get the container element by id (should be defined in a public wrapper)
    const elContainer = document.getElementById('idLzNotificationsContainer');

    // If not defined then show as alert and skip
    if (!elContainer) {
        alert(heading + "\n" + message);
        return;
    }

    // Add the message as html to the element
    const elDiv = document.createElement('div');
    elDiv.className = 'lz-notifications-message lz-notifications-message-' + type;
    elDiv.innerHTML = '<button type="button" onclick="window.lzFNotificationsMessageRemove(this.parentNode)">x</button>' +
        '<strong>' + heading + '</strong>' +
        '<pre>' + message + '</pre>';
    elContainer.appendChild(elDiv).focus();
    elDiv.className += ' lz-notifications-message-appear';

    // Apply timeout if requested
    if (timeoutMilliseconds > 0) {
        window.setTimeout(() => lzFNotificationsMessageRemove(elDiv), timeoutMilliseconds);
    }
};

export const lzFNotificationsShowDefault = (message: string, heading?: string): void => {
    lzFNotificationsShow("default", message, heading || 'Hey!', 6000);
};

export const lzFNotificationsShowPrimary = (message: string, heading?: string): void => {
    lzFNotificationsShow("primary", message, heading || 'Hey!', 6000);
};

export const lzFNotificationsShowSecondary = (message: string, heading?: string): void => {
    lzFNotificationsShow("secondary", message, heading || 'Hey!', 6000);
};

export const lzFNotificationsShowError = (message: string, heading?: string): void => {
    lzFNotificationsShow("error", message, heading || 'Yikes!', 6000);
};

export const lzFNotificationsShowWarning = (message: string, heading?: string): void => {
    lzFNotificationsShow("warning", message, heading || 'Oops!', 6000);
};

export const lzFNotificationsShowInfo = (message: string, heading?: string): void => {
    lzFNotificationsShow("info", message, heading || 'Ehm!', 6000);
};

export const lzFNotificationsShowSuccess = (message: string, heading?: string): void => {
    lzFNotificationsShow("success", message, heading || 'Hooray!', 3000);
};
